export function useSaveFileLocally() {
  const saveFileLocally = (blob: Blob, fileName: string) => {
    const aTag = document.createElement('a');
    aTag.setAttribute('display', 'none');
    document.body.appendChild(aTag);

    const url = URL.createObjectURL(blob);
    aTag.setAttribute('href', url);
    aTag.setAttribute('download', fileName);
    aTag.click();

    // Clear resources to avoid memory leak
    aTag.remove();
    URL.revokeObjectURL(url);

    return true;
  };

  const getFileNameFromContentDisposition = (headerString: string) => {
    const fileName = headerString
      ?.split(';')
      ?.map((part) => part.trim())
      ?.find((part) => part.startsWith('filename='))
      ?.split('=')[1]
      ?.replace(/^["']|["']$/g, '');

    if (!fileName) {
      throw new Error('Can\'t get file name');
    }

    return fileName;
  };

  return {
    saveFileLocally,
    getFileNameFromContentDisposition
  } as const;
}
